import React from 'react';

interface AvatarProps {
  src?: string;
  name: string;
}

export const Avatar: React.FC<AvatarProps> = ({ src, name }) => (
  <div className="flex items-center gap-2 print:gap-1 print:w-full print:justify-start">
    {src ? (
      <img
        src={src}
        alt={name}
        className="w-8 h-8 rounded-full object-cover border-2 border-white shadow-sm print:w-6 print:h-6 flex-shrink-0"
      />
    ) : (
      <div className="w-8 h-8 rounded-full bg-blue-100 flex items-center justify-center border-2 border-white shadow-sm print:w-6 print:h-6 flex-shrink-0">
        <span className="text-blue-600 text-sm font-medium">
          {name.charAt(0).toUpperCase()}
        </span>
      </div>
    )}
    <span className="text-gray-700 flex-shrink-0">{name}</span>
  </div>
);